import type { Market } from '@hultafors/shared/types';

export const markets: Market[] = [
  {
    defaultCoords: {
      latitude: 57.6983323,
      longitude: 12.7388379,
    },
    hostname: 'www.hultaforsgroup.com',
    languages: [{ datoLocale: 'en', lang: 'en' }],
    market: 'com',
  },
  {
    defaultCoords: {
      latitude: 47.631858269895794,
      longitude: 13.797778364631036,
    },
    hostname: 'www.hultaforsgroup.at',
    languages: [{ datoLocale: 'de_AT', lang: 'de-AT' }],
    market: 'at',
  },
  {
    defaultCoords: {
      latitude: 50.6182138854095,
      longitude: 4.675010154696485,
    },
    hostname: 'www.hultaforsgroup.be',
    languages: [{ datoLocale: 'nl_BE', lang: 'nl-BE' }],
    market: 'be',
  },
  {
    defaultCoords: {
      latitude: 46.73678128684938,
      longitude: 8.286928794895285,
    },
    hostname: 'www.hultaforsgroup.ch',
    languages: [
      { datoLocale: 'de_CH', lang: 'de-CH', name: 'Deutsch' },
      { datoLocale: 'fr_CH', lang: 'fr-CH', name: 'Français', urlPrefix: 'fr' },
    ],
    market: 'ch',
  },
  {
    defaultCoords: {
      latitude: 51.08304539800482,
      longitude: 10.426171427430804,
    },
    hostname: 'www.hultaforsgroup.de',
    languages: [{ datoLocale: 'de', lang: 'de-DE' }],
    market: 'de',
  },
  {
    defaultCoords: {
      latitude: 56.00118817971057,
      longitude: 9.378670542409406,
    },
    hostname: 'www.hultaforsgroup.dk',
    languages: [{ datoLocale: 'da', lang: 'da-DK' }],
    market: 'dk',
  },
  {
    defaultCoords: {
      latitude: 65.01578959749911,
      longitude: 25.65738433454702,
    },
    hostname: 'www.hultaforsgroup.fi',
    languages: [{ datoLocale: 'fi', lang: 'fi-FI' }],
    market: 'fi',
  },
  {
    defaultCoords: {
      latitude: 46.6423682169416,
      longitude: 2.1940236627886227,
    },
    hostname: 'www.hultaforsgroup.fr',
    languages: [{ datoLocale: 'fr_FR', lang: 'fr-FR' }],
    market: 'fr',
  },
  {
    defaultCoords: {
      latitude: 53.30489539816495,
      longitude: -8.241128545554096,
    },
    hostname: 'www.hultaforsgroup.ie',
    languages: [{ datoLocale: 'en_IE', lang: 'en-IE' }],
    market: 'ie',
  },
  {
    defaultCoords: {
      latitude: 42.98201127614267,
      longitude: 12.763657166123137,
    },
    hostname: 'www.hultaforsgroup.it',
    languages: [{ datoLocale: 'it_IT', lang: 'it-IT' }],
    market: 'it',
  },
  {
    defaultCoords: {
      latitude: 52.134054128923886,
      longitude: 5.554136426128487,
    },
    hostname: 'www.hultaforsgroup.nl',
    languages: [{ datoLocale: 'nl_NL', lang: 'nl-NL' }],
    market: 'nl',
  },
  {
    defaultCoords: {
      latitude: 64.97775882947745,
      longitude: 16.670259272390894,
    },
    hostname: 'www.hultaforsgroup.no',
    languages: [{ datoLocale: 'no', lang: 'no-NB' }],
    market: 'no',
  },
  {
    defaultCoords: {
      latitude: 52.06848055692473,
      longitude: 19.43573279234468,
    },
    hostname: 'www.hultaforsgroup.pl',
    languages: [{ datoLocale: 'pl_PL', lang: 'pl-PL' }],
    market: 'pl',
  },
  {
    defaultCoords: {
      latitude: 62.73420986108448,
      longitude: 17.062431988004956,
    },
    hostname: 'www.hultaforsgroup.se',
    languages: [{ datoLocale: 'sv', lang: 'sv-SE' }],
    market: 'se',
  },
  {
    defaultCoords: {
      latitude: 53.97844735080214,
      longitude: -2.852943909329258,
    },
    hostname: 'www.hultaforsgroup.co.uk',
    languages: [{ datoLocale: 'en_GB', lang: 'en-GB' }],
    market: 'uk',
  },
];
